import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export interface AccessInformation {
  ip: string | string[] | undefined;
  userAgent: string | string[] | undefined;
}

/**
 * Which code path wrote the change. `Resource` names what was edited and is
 * the same for every surface, so it cannot answer "where did this come from".
 */
export enum SettingsWriteSource {
  AdminApp = "admin-app",
  MerchantApp = "merchant-app",
  Onboarding = "onboarding",
  ManageScript = "manage-script",
  IntegrationSync = "integration-sync",
  DemoStoreTool = "demo-store-tool",
}

const BaseAuditLogSchema = z.object({
  _id: zExt.objectId(),
  type: z.string(),
  team: zExt.objectId().optional(),
  user: z.string().optional(),
  userId: zExt.objectId().optional(),
  Resource: z.string().optional(),
  access: z.any().optional(),
  /**
   * Permissive on read: this schema is the audit-log RPC output contract, and
   * output validation failure throws a 500. A value outside a strict enum --
   * from a newer writer during a rolling deploy, or a later enum addition --
   * would break the viewer. Writers use SettingsWriteSource for safety.
   */
  source: z.string().optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const SettingsAuditLogSchema = BaseAuditLogSchema.extend({
  type: z.literal("setting"),
  path: z.string().optional(),
  prev: z.any().optional(),
  next: z.any().optional(),
});

export type SettingsAuditLog = z.infer<typeof SettingsAuditLogSchema>;

export enum TexasSegmentRemovalDocumentType {
  CAMPAIGN = "campaign",
  AUTOMATION = "automation",
}
const texasSegmentRemovalAuditLogSchema = BaseAuditLogSchema.extend({
  type: z.literal("texasSegmentRemoval"),
  documentType: createEnum(TexasSegmentRemovalDocumentType),
  documentId: zExt.objectId(),
});

export const AuditLogSchema = z.discriminatedUnion("type", [
  SettingsAuditLogSchema,
  texasSegmentRemovalAuditLogSchema,
]);
export type AuditLog = z.infer<typeof AuditLogSchema>;
